import BossModel from "@/models/BossModel";

export default class InternalHelpText extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'internal-help-text';

    /**
     *
     * @type {string}
     */
    static entity = 'internalHelpTexts';

    static fields() {
		return {
			id: this.attr(null),
			key: this.attr(null),
			text: this.attr(null),
			created_at: this.attr(null),
			updated_at: this.attr(null),
		}
	}
}
